import { useState, useEffect } from 'react';

const AUTO_SAVE_PREFERENCE_KEY = 'article_autosave_interval';

export type AutoSaveInterval = 15000 | 30000 | 60000 | 0; // in milliseconds

export const useAutoSavePreference = () => {
  const [interval, setIntervalState] = useState<AutoSaveInterval>(() => {
    try {
      const saved = localStorage.getItem(AUTO_SAVE_PREFERENCE_KEY);
      if (saved) {
        const parsed = parseInt(saved);
        if ([15000, 30000, 60000, 0].includes(parsed)) {
          return parsed as AutoSaveInterval;
        }
      }
    } catch (error) {
      console.error('Failed to load auto-save preference:', error);
    }
    return 30000; // Default to 30 seconds
  });

  const setInterval = (newInterval: AutoSaveInterval) => {
    try {
      localStorage.setItem(AUTO_SAVE_PREFERENCE_KEY, newInterval.toString());
      setIntervalState(newInterval);
    } catch (error) {
      console.error('Failed to save auto-save preference:', error);
    }
  };

  return { interval, setInterval };
};

export const getIntervalLabel = (interval: AutoSaveInterval): string => {
  switch (interval) {
    case 15000:
      return 'Every 15 seconds';
    case 30000:
      return 'Every 30 seconds';
    case 60000:
      return 'Every 60 seconds';
    case 0:
      return 'Disabled';
    default:
      return 'Every 30 seconds';
  }
};
